export default __webpack_public_path__ + "static/palchyn-297865c6a6ac5c8c9525b765e16fa802.png";